import { CiTimer } from "react-icons/ci";
import { Button } from "../../components/forms";
import { MdClearAll, MdHome, MdOutlineBookmarkAdd } from "react-icons/md";
import { IoMdQrScanner } from "react-icons/io";
import { GoHistory } from "react-icons/go";
import ScanItem from "../../components/generic/ScanItem";
import { getuserById, onGetSaveScan } from "../../services/user";
import { useEffect, useState } from "react";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { useNavigate } from "react-router-dom";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import EmptyList from "../../components/generic/EmptyList";
import useSound from "use-sound";
import { useMediaQuery } from "react-responsive";
import { toast } from "react-toastify";
import ViewDetailsModal from "../../components/generic/ViewDetailsModal";
import { ScanItemDTO } from "../../utils/typings";

export default () => {
  const navigate = useNavigate();
  const isDesktopOrLaptop = useMediaQuery({ query: "(min-width: 644px)" });
  const { authuser } = useStateGetter();
  const [savedscan, setsavedscan] = useState([]);
  const { setLoading, setAuthuser, setConfig } = useStateSetter();
  const [showDetails, setshowDetails] = useState(false);
  const [selectedscan, setselectedscan] = useState<any>({});
  const [jsonItem, setjsonItem] = useState<ScanItemDTO>();
  const refreshuser = async () => {
    try {
      var res = await getuserById(authuser.id);
      // localStorage.clear();
      if (res.user) {
        localStorage.setItem(`UserData`, JSON.stringify(res?.user));
        localStorage.setItem(`AuthToken`, res?.token);
        setAuthuser(res?.user);
        const config = {
          headers: {
            Authorization: `Bearer ${res?.token}`,
          },
        };
        setConfig(config);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getuserSaved = async () => {
    let postdata = {
      userid: authuser.id,
    };

    setLoading(true);

    try {
      var res = await onGetSaveScan(postdata);

      setsavedscan(res);
    } catch (e: any) {
      toast.error(e);
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    selectedscan.market != "Strategy generator" &&
      setjsonItem(JSON.parse(selectedscan.content ? selectedscan.content : "{}"));
  }, [selectedscan]);

  
  useEffect(() => {
    refreshuser();
    getuserSaved();
  }, []);
  return (
    <div className="w-full  ">
      {showDetails && (
        <ViewDetailsModal
          setselectedscan={setselectedscan}
          item={
            selectedscan.market != "Strategy generator"
              ? jsonItem
              : selectedscan
          }
          show={setshowDetails}
        />
      )}

      <div className=" w-full       bg-white    flex justify-between   items-start flex-col md:flex-row mb-4 ">
        <p className="font-semibold font-serif text-gray-500">
          <MdHome size={30} className="text-primary m-3 inline " /> Home
        </p>
        <hr />

        {!isDesktopOrLaptop && (
          <div className="  w-full md:w-[40%] self-end md:p-6 flex gap-2  justify-center items-center  ">
            <Button
              width={200}
              outlined
              text={
                <>
                  {" "}
                  <MdClearAll className="inline" />
                  Strategy generator
                </>
              }
              onBtnClick={() => {
                navigate("/strategy");
              }}
            />

            <Button
              text={
                <>
                  {" "}
                  <IoMdQrScanner className="inline" /> Signal room{" "}
                </>
              }
              width={200}
              outlined
              onBtnClick={() => {
                 navigate("/signalroom");
              }}
            />
          </div>
        )}
      </div>
      <p className="font-[400] text-gray-700 my-2  ">
        <GoHistory className="text-gray-400 mx-2 inline  " />
        Recently saved market scans
      </p>
      <div className="  w-full md:w-[50%] self-end md:p-6 flex gap-2  justify-center items-center  ">
        <Button
          width={200}
          outlined
          text={
            <>
              {" "}
              <MdClearAll className="inline" /> View all{" "}
            </>
          }
          onBtnClick={() => {
            navigate("/allscans");
          }}
        />
        <Button
          text={
            <>
              {" "}
              <IoMdQrScanner className="inline" /> Scan now{" "}
            </>
          }
          width={200}
          onBtnClick={() => {
            navigate("/scanner");
          }}
        />

        {isDesktopOrLaptop && (
          <Button
            text={
              <>
                {" "}
                <IoMdQrScanner className="inline" /> Signal room{" "}
              </>
            }
            width={200}
            outlined
            onBtnClick={() => {
              navigate("/signalroom");
            }}
          />
        )}
      </div>

      {savedscan.length != 0 ? (
        <div className="px-2 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-4 overflow-y-scroll overflow-x-hidden h-[70vh] py-2">
          {[...savedscan]
            .reverse()
            .slice(0, 6)
            ?.map((item: any) => (
              <ScanItem  setshowmodal={setshowDetails}       setselectedscan={setselectedscan}
              refresh={getuserSaved} item={item} />
            ))}
        </div>
      ) : (
        <EmptyList />
      )}
    </div>
  );
};
